<template>
  <!-- 费用报销 -->
  <div :class="recycleBinShow ? '' : 'drawerStyle'">
    <div class="rightMo">
      <div v-if="!isIndexPage" class="filter-container">
        <div class="query-row filter-row">
          <b>审核状态：</b>
          <a-radio-group
            name="radioGroup"
            v-model="character.checkStatus"
            @change="(e) => radioGroupChange(e, 'checkStatus', 'expenseReim')"
            :default-value="1"
            style="margin-right: 20px;"
          >
            <a-radio value>全部</a-radio>
            <a-radio
              v-for="(item, index) in checkStatusList"
              :key="index"
              :value="item.value"
            >{{ item.label }}</a-radio>
          </a-radio-group>
          <b>支取状态：</b>
          <a-radio-group
            v-model="character.drawStatus"
            name="radioGroup"
            @change="(e) => radioGroupChange(e, 'drawStatus', 'expenseReim')"
          >
            <a-radio value>全部</a-radio>
            <a-radio :value="0">未支取</a-radio>
            <a-radio :value="1">已支取</a-radio>
          </a-radio-group>
        </div>
        <div>
          <div class="search-row-8xxx">
            <b>报销主题/客户名称关键字：</b>
            <a-input
              v-model="queryDataObj.searchCondition"
              placeholder="请输入主题/客户关键字"
              class="filter-item search-item"
              @pressEnter="queryClick"
              allow-clear
            />
            <b>创建人：</b>
            <a-input
              v-model="queryDataObj.creator"
              placeholder="请输入创建人"
              class="filter-item search-item"
              @pressEnter="queryClick"
              allow-clear
            />
            <!-- <b>对应项目：</b>
            <a-input v-model="character.project" placeholder="输入对应项目关键字" class="filter-item search-item" @pressEnter="queryClick"/>-->
            <b>对应项目：</b>
            <a-input
              v-model="queryDataObj.projectName"
              placeholder="点击选择项目"
              style="width: 200px;"
              read-only
              class="filter-item search-item"
              @click="openModal('project')"
            >
              <a-icon
                v-show="queryDataObj.projectName"
                slot="suffix"
                type="close-circle"
                style="cursor: pointer;"
                @click="clearProject"
              />
            </a-input>
            <b>对应销售机会：</b>
            <a-input
              v-model="queryDataObj.opportunityTitle"
              style="width: 200px;"
              placeholder="点击选择对应销售机会"
              class="filter-item search-item"
              read-only
              @click="openModal('salesOpportunities')"
            >
              <a-icon
                v-show="queryDataObj.opportunityTitle"
                slot="suffix"
                type="close-circle"
                style="cursor: pointer;"
                @click="clearOpportunityTitle"
              />
            </a-input>
          </div>
        </div>
        <div class="query-row">
          <!-- <b>申请时间: </b><range-date @change="handleDateChange" ref="createTime" style="width: 240px;margin-left:10px;" class="filter-item search-item"></range-date> -->
          <div class="search-row-6xls">
            <b>申请开始日期：</b>
            <a-date-picker
              @change="onChangeDateStart"
              valueFormat="YYYY-MM-DD"
              v-model="queryDataObj.reimbursementDateStart"
              class="filter-item search-item"
              placeholder="请选择开始日期"
            />
            <b>申请结束日期：</b>
            <a-date-picker
              @change="onChangeDateEnd"
              valueFormat="YYYY-MM-DD"
              v-model="queryDataObj.reimbursementDateEnd"
              class="filter-item search-item"
              placeholder="请选择结束日期"
            />
            <div>
              <a-button type="primary" class="filter-item" @click="queryClick">查询</a-button>
              <advancedSearch
                class="filter-item filter-button"
                @advancedSearch="advancedSearch"
                @save="save"
              />
              <a-button class="filter-item filter-button" @click="resetClick">重置</a-button>
            </div>
          </div>
        </div>
        <a-button
          v-if="!recycleBinShow"
          v-hasPermission="'reimbursement:add'"
          type="primary"
          icon="plus-circle"
          class="filter-item add-but"
          @click="addClick"
        >新建{{this.$tree([], 'financialManage/expenseReim/index')}}</a-button>
        <a-button
          v-if="!recycleBinShow"
          v-hasPermission="'reimbursement:exportAll'"
          icon="download"
          class="filter-item add-but"
          @click="exportClick"
          style="margin-left: 6px;background-color: rgb(250, 173, 20); color: white"
        >导出{{this.$tree([], 'financialManage/expenseReim/index')}}</a-button>
      </div>
      <div class="contentdiv">
        <a-table
          :columns="filterColumn"
          :data-source="tableData"
          :loading="tableLoadding"
          :pagination="pagination"
          :components="componentesd"
          :rowKey="(record,index)=>{return index}"
          :scroll="tableScroll"
          :size="tableSize"
          @change="pageChange"
          bordered
          class="tableClass"
        >
          <template slot="fileIds" slot-scope="text, record">
            <a-icon
              type="paper-clip"
              v-if="record.fileIds && record.fileIds !== null && record.fileIds !==''"
              :style="'color:' + storageColor"
            />
          </template>
          <span slot="filterDropdown">
            <a-card>
              <a-checkbox-group
                style="display:grid"
                v-model="columnList"
                :options="checkColumn"
                :defaultValue="checkColumn"
                @change="checkChange"
              />
              <a-tag
                color="green"
                @click="getColumns('expenseReim')"
                style="position: absolute; right: 5px; bottom: 5px"
              >确认</a-tag>
            </a-card>
          </span>
          <template slot="subject" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">{{record.subject}}</template>
              <span
                v-if="!isIndexPage"
                @click="subjectClick(record.id)"
                class="onClickStyle"
              >{{ record.subject }}</span>
              <span v-else>{{ record.subject }}</span>
            </a-tooltip>
          </template>
          <template slot="project" slot-scope="text, record">
            <a-tooltip placement="topLeft" v-if="record.opportunityId && record.opportunityTitle">
              <template slot="title">{{record.opportunityTitle}}</template>
              <span
                @click="openView(record, 'salesOpportunities')"
                class="onClickStyle"
              >{{record.opportunityTitle}}</span>
            </a-tooltip>
            <a-tooltip placement="topLeft" v-else>
              <template slot="title">{{record.project}}</template>
              <span @click="openView(record, 'project')" class="onClickStyle">{{record.project}}</span>
            </a-tooltip>
          </template>
          <!-- <template slot="opportunityTitle" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">{{record.opportunityTitle}}</template>
              <span
                @click="openView(record, 'salesOpportunities')"
                class="onClickStyle"
              >{{record.opportunityTitle}}</span>
            </a-tooltip>
          </template>-->
          <template slot="customerType" slot-scope="text, record">
            <span>{{ clientObj[record.customerType] }}</span>
          </template>
          <template slot="customerName" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">{{record.customerName}}</template>
              <span
                @click="openView(record, 'customerName')"
                class="onClickStyle"
              >{{record.customerName}}</span>
            </a-tooltip>
          </template>
          <template slot="amount" slot-scope="text, record">
            <span>￥{{ parseFloat(record.amount).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) || '0.00'}}</span>
          </template>
          <template slot="checkTime" slot-scope="text, record" v-if="record.checkTime">
            <span>{{ record.checkTime.slice(0, 11) }}</span>
          </template>
          <template slot="drawStatus" slot-scope="text, record">
            <a-tag color="green" v-if="record.drawStatus === 1">已支取</a-tag>
            <a-tag color="orange" v-else-if="record.drawStatus === 0">未支取</a-tag>
          </template>
          <template slot="projectSlot" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">{{record.project}}</template>
              <span @click="openView(record, 'project')" class="onClickStyle">{{record.project}}</span>
            </a-tooltip>
          </template>
          <template slot="checkStatus" slot-scope="text, record">
            <a-tag color="orange" v-if="record.checkStatus === 0">未审核</a-tag>
            <a-tag color="cyan" v-if="record.checkStatus === 1">审核中</a-tag>
            <a-tag color="green" v-if="record.checkStatus === 2">审核通过</a-tag>
            <a-tag color="red" v-if="record.checkStatus === 3">审核不通过</a-tag>
            <a-tag color="orange" v-if="record.checkStatus === 4">待我审批</a-tag>
            <span
              v-if="record.checkStatus !== null && (record.creator === nowUserName || record.peopleName === nowUserName) && record.drawStatus !== 1"
            >
              <a-divider type="vertical" />
              <a-popconfirm title="确定撤回该条数据吗?" @confirm="() => revocationClick(record)">
                <a-tag class="operationStyle">
                  <a-tooltip>
                    <template slot="title">撤回</template>
                    <a-icon type="rollback" />
                  </a-tooltip>撤回
                </a-tag>
              </a-popconfirm>
            </span>
          </template>
          <template slot="oherOperation" slot-scope="text, record">
            <span v-if="!recycleBinShow">
              <!-- 无需权限 当前用户=申请人/所有者 则可对数据进行修改操作(草稿状态可修改、审核状态有蒙层)  草稿状态才可删除-->
              <span v-if="record.creator === nowUserName">
                <span v-hasPermission="'reimbursement:draw'">
                  <span v-if="record.drawStatus !== 1 && record.checkStatus === 2">
                    <a-popconfirm title="确定该款项已支取，更改后状态无法更改！" @confirm="() => drawClick(record)">
                      <a-tooltip>
                        <template slot="title">支取</template>
                        <a-icon type="check-circle" class="pointStyle" style="color:#2db7f5" />
                      </a-tooltip>
                    </a-popconfirm>
                    <a-divider type="vertical" />
                  </span>
                </span>
                <a-tooltip>
                  <template slot="title">修改</template>
                  <a-icon
                    type="edit"
                    theme="twoTone"
                    style="font-size: 16px;"
                    twoToneColor="#1890ff"
                    @click="editClick(record)"
                  />
                </a-tooltip>
                <span v-if="record.checkStatus === null ">
                  <a-divider type="vertical" />
                  <a-popconfirm
                    v-if="tableData.length"
                    title="确定删除这条数据吗?"
                    @confirm="() => onDelete(record.id)"
                  >
                    <a-tooltip>
                      <template slot="title">删除</template>
                      <a-icon
                        type="delete"
                        style="font-size: 16px; cursor: pointer;"
                        theme="twoTone"
                        twoToneColor="red"
                      />
                    </a-tooltip>
                  </a-popconfirm>
                </span>
              </span>
              <!-- 当勾选了update、delete、draw权限时  可修改/查看数据(进入审核流程数据仅查看、草稿状态可修改)  草稿状态可删除  审核状态为通过可支取-->
              <span v-else>
                <span v-hasPermission="'reimbursement:draw'">
                  <span v-if="record.drawStatus !== 1 && record.checkStatus === 2">
                    <a-popconfirm title="确定该款项已支取，更改后状态无法更改！" @confirm="() => drawClick(record)">
                      <a-tooltip>
                        <template slot="title">支取</template>
                        <a-icon type="check-circle" class="pointStyle" style="color:#2db7f5" />
                      </a-tooltip>
                    </a-popconfirm>
                    <a-divider type="vertical" />
                  </span>
                </span>
                <span v-hasPermission="'reimbursement:update'">
                  <a-tooltip>
                    <template slot="title">修改</template>
                    <a-icon
                      type="edit"
                      theme="twoTone"
                      style="font-size: 16px;"
                      twoToneColor="#1890ff"
                      @click="editClick(record)"
                    />
                  </a-tooltip>
                </span>
                <span v-hasPermission="'reimbursement:delete'">
                  <span v-if="record.checkStatus === null ">
                    <a-divider type="vertical" />
                    <a-popconfirm
                      v-if="tableData.length"
                      title="确定删除这条数据吗?"
                      @confirm="() => onDelete(record.id)"
                    >
                      <a-tooltip>
                        <template slot="title">删除</template>
                        <a-icon
                          type="delete"
                          style="font-size: 16px; cursor: pointer;"
                          theme="twoTone"
                          twoToneColor="red"
                        />
                      </a-tooltip>
                    </a-popconfirm>
                  </span>
                </span>
              </span>
            </span>
            <span v-if="recycleBinShow">
              <span>
                <a-popconfirm title="确定恢复该数据吗？" @confirm="() => recovery(record)">
                  <a-tooltip>
                    <template slot="title">恢复</template>
                    <a-icon type="sync" class="pointStyle" style="color:#2db7f5" />
                  </a-tooltip>
                </a-popconfirm>
                <a-divider type="vertical" />
              </span>
              <span>
                <a-popconfirm title="确定删除这条数据吗？删除无法恢复！" @confirm="() => deleteRecy(record)">
                  <a-tooltip>
                    <template slot="title">删除</template>
                    <a-icon type="delete" class="pointStyle" style="color:red" />
                  </a-tooltip>
                </a-popconfirm>
                <!-- <a-divider type="vertical"/> -->
              </span>
            </span>
          </template>
          <template v-if="!isIndexPage" #footer>
            <totals
              :columnv="filterColumnv"
              :footerDataSource="footerDataSource"
              :scrolls="scrolls"
            />
          </template>
        </a-table>
      </div>
    </div>
    <add-edit-vue
      ref="addEditRef"
      :title="addTitle"
      :dialog-visible="addVisible"
      :client-type="clientType"
      :duty-person-list="dutyPersonList"
      @success="addSuccess"
      @close="addClose"
    />
    <audit-vue
      ref="auditRef"
      :dialog-visible="auditVisible"
      @success="auditSucc"
      @close="auditClose"
    />
    <!-- <a-drawer
      width="50%"
      :destroyOnClose="true"
      title="[查看]费用报销记录"
      placement="right"
      :closable="false"
      :visible="drawerVisible"
      @close="drawerOnClose"
    >
      <show-vue ref="showRef" />
    </a-drawer>-->
    <copy-drawer
      ref="publicDrawerRef"
      :title="publicDrawer.title"
      :dialog-visible="publicDrawer.visible"
      :component-name="publicDrawer.comName"
      @projectChanges="projectChanges"
      @editClick="subjectClick"
      @close="publicDrawerClose"
    />
    <click-view ref="clickViewRef" :dialog-visible="clickViewVisible" @close="clickViewClose" />
    <public-dialog
      :title="publicDia.title"
      :dialog-visible="publicDia.visible"
      :component-name="publicDia.comName"
      :isSale="true"
      @logSuccess="publicDialogSucc"
      @cancel="publicDialogCancel"
    />
  </div>
</template>

<script>
import addEditVue from './addEdit.vue'
import auditVue from './audit.vue'
import showVue from './show.vue'
import clickView from '@/components/view/clickView.vue'
import copyDrawer from '../../../components/drawer/copyDrawer.vue'
import totals from '../../common/totals.vue'
import RangeDate from '@/components/datetime/RangeDate'
import { total } from '../../../utils/totals'
// import {getProjectNameById, getCustomerNameById} from '../../../utils/index'
import db from '@/utils/localstorage'
import advancedSearch from '@/components/advancedSearch/index.vue'
import publicDialog from '@/components/modelDialog/publicDialog.vue'
import { mixin } from '@/mixin/index.js'
import { getQuery } from '@/mixin/getQuery.js'

export default {
  name: 'Idenx',
  components: { addEditVue, auditVue, showVue, clickView, totals, copyDrawer, RangeDate, advancedSearch, publicDialog },
  props: {
    // 是否为首页模块
    isIndexPage: {
      type: Boolean,
      default: false
    },
    recycleBinShow: {
      type: Boolean,
      default: false
    },
    ids: { //  费用报销汇总列表进入查询
      type: String,
      default: ''
    }
  },
  mixins: [getQuery, mixin],
  provide () {
    return {
      advancedEnquiries: this
    }
  },
  data () {
    return {
      dataForm: {},
      publicDia: { visible: false },
      tableScroll: { y: 380, x: 1780 },
      nowUserName: db.get('USER').username,
      tableSize: 'middle',
      storageColor: this.$db.get('COLOR')[0],
      character: {
        checkStatus: '',
        drawStatus: '',
        reimbursementDateStart: null,
        reimbursementDateEnd: null
      },
      checkStatusList: [],
      checkStatusObj: {},
      publicDrawer: {
        title: '',
        visible: false,
        comName: ''
      },
      tableLoadding: false,
      scrolls: { x: 1780 },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true // 是否可以改变pageSize
      },
      indexPageColumns: [
        {
          title: '报销主题',
          width: 150,
          align: 'center',
          dataIndex: 'subject',
          ellipsis: true,
          scopedSlots: { customRender: 'subject' }
        },
        {
          width: 120,
          align: 'center',
          title: '报销金额',
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' }
        },
        {
          width: 80,
          align: 'center',
          ellipsis: true,
          title: '申请人',
          dataIndex: 'peopleName'
        },
        {
          width: 120,
          align: 'center',
          title: '申请时间',
          dataIndex: 'reimbursementDate'
        },
        {
          width: 160,
          title: '项目名称',
          align: 'center',
          dataIndex: 'project',
          ellipsis: true,
          scopedSlots: { customRender: 'projectSlot' }
        },
        {
          // width: 250,
          align: 'center',
          title: '审核状态',
          dataIndex: 'checkStatus',
          scopedSlots: { customRender: 'checkStatus' }
        },
        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 120,
          dataIndex: 'oherOperation',
          scopedSlots: { customRender: 'oherOperation' }
        }
      ],
      footerDataSource: [
        {
          id: '本页',
          amount: 0,
          oherOperation: '-'
        },
        {
          id: '总计',
          amount: 0,
          oherOperation: '-'
        }
      ],
      columnv: [
        {
          title: 'ID',
          ellipsis: true,
          dataIndex: 'id',
          width: 58,
          customCell: () => {
            return {
              style: {
                fontWeight: 900
              }
            }
          },
          align: 'center'
        },
        {
          title: '附',
          dataIndex: 'fileIds',
          width: 48,
          ellipsis: true,
          scopedSlots: { customRender: 'fileIds' }
        },
        {
          title: '报销主题',
          dataIndex: 'subject',
          width: 130,
          ellipsis: true,
          scopedSlots: { customRender: 'subject' }
        },
        {
          title: '对应项目/销售机会',
          dataIndex: 'project',
          width: 250,
          ellipsis: true,
          scopedSlots: { customRender: 'project' }
        },
        // {
        //   title: '对应销售机会',
        //   dataIndex: 'opportunityTitle',
        //   width: 130,
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'opportunityTitle' }
        // },
        {
          width: 80,
          title: '申请人',
          dataIndex: 'peopleName'
        },
        {
          width: 120,
          title: '申请时间',
          dataIndex: 'reimbursementDate'
        },
        {
          title: '客户名称',
          dataIndex: 'customerName',
          width: 130,
          ellipsis: true,
          scopedSlots: { customRender: 'customerName' }
        },
        {
          width: 120,
          title: '报销金额',
          dataIndex: 'amount',
          ellipsis: true,
          customCell: () => {
            return {
              style: {
                fontWeight: 900
              }
            }
          },
          scopedSlots: { customRender: 'amount' }
        },
        {
          width: 80,
          title: '创建人',
          dataIndex: 'creator'
        },
        {
          width: 100,
          title: '支取状态',
          dataIndex: 'drawStatus',
          scopedSlots: { customRender: 'drawStatus' }
        },
        {
          width: 120,
          title: '支取日期',
          dataIndex: 'drawTime'
        },
        {
          width: 120,
          title: '审批日期',
          dataIndex: 'checkTime',
          ellipsis: true,
          scopedSlots: { customRender: 'checkTime' }
        },
        {
          // width: 230,
          align: 'center',
          title: '审核状态',
          dataIndex: 'checkStatus',
          scopedSlots: { customRender: 'checkStatus' }
        },
        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 120,
          dataIndex: 'oherOperation',
          scopedSlots: { customRender: 'oherOperation' }
        }
      ],
      tableData: [],
      addVisible: false,
      addTitle: '',
      clientType: [],
      clientObj: {},
      auditVisible: false,
      drawerVisible: false,
      dutyPersonList: [],
      clickViewVisible: false,
      sortedInfo: null,
      advancedEnquiries: [
        {
          type: 'project',
          label: '对应项目',
          layout: 24,
          key: 'project',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'customer',
          label: '客户/供应商',
          all: true,
          layout: 24,
          key: 'customer',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'input',
          label: '主题',
          layout: 24,
          key: 'subject',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'numberInput',
          label: '报销金额',
          layout: 24,
          key: ['amountStart', 'amountEnd'],
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'date',
          label: '申请开始日期',
          key: 'reimbursementDateStart',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'date',
          label: '申请结束日期',
          key: 'reimbursementDateEnd',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'date',
          label: '支取日期起始',
          key: 'drawTimeStart',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'date',
          label: '支取日期结束',
          key: 'drawTimeEnd',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'input',
          label: '申请人',
          key: 'peopleName',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'input',
          label: '创建人',
          key: 'creator',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'radio',
          label: '支取状态',
          layout: 24,
          key: 'drawStatus',
          content: [
            { label: '全部', value: '' },
            { label: '未支取', value: 0 },
            { label: '已支取', value: 1 }
          ],
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'radio',
          label: '审核状态',
          layout: 24,
          key: 'checkStatus',
          keyLabel: ['label', 'value'],
          content: [
            {
              label: '全部',
              value: ''
            }
          ],
          defaultModel: true,
          modelKey: 'queryDataObj'
        }
        // {
        //   type: 'person',
        //   isOnce: false,
        //   label: '抄送人',
        //   layout: 24,
        //   key: 'user'
        // }
      ],
      columns: [
        {
          title: 'ID',
          ellipsis: true,
          dataIndex: 'id',
          width: 60,
          // sorter: (a, b) => a.id - b.id,
          align: 'center'
        },
        {
          title: '附',
          dataIndex: 'fileIds',
          width: 48,
          ellipsis: true,
          scopedSlots: { customRender: 'fileIds' }
        },
        {
          title: '报销主题',
          dataIndex: 'subject',
          width: 130,
          ellipsis: true,
          scopedSlots: { customRender: 'subject' }
        },
        {
          title: '对应项目/销售机会',
          dataIndex: 'project',
          width: 250,
          ellipsis: true,
          scopedSlots: { customRender: 'project' }
        },
        // {
        //   title: '对应销售机会',
        //   dataIndex: 'opportunityTitle',
        //   width: 130,
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'opportunityTitle' }
        // },
        {
          width: 80,
          ellipsis: true,
          title: '申请人',
          dataIndex: 'peopleName'
        },
        {
          width: 120,
          title: '申请时间',
          dataIndex: 'reimbursementDate',
          align: 'center'
        },
        {
          title: '客户名称',
          dataIndex: 'customerName',
          width: 130,
          ellipsis: true,
          scopedSlots: { customRender: 'customerName' }
        },
        {
          width: 120,
          title: '报销金额',
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' },
          sorter: true,
          filterMultiple: false,
          sortDirections: ['descend', 'ascend']
        },
        {
          width: 80,
          ellipsis: true,
          title: '创建人',
          dataIndex: 'creator'
        },
        {
          width: 100,
          title: '支取状态',
          dataIndex: 'drawStatus',
          scopedSlots: { customRender: 'drawStatus' }
        },
        {
          width: 120,
          title: '支取日期',
          dataIndex: 'drawTime'
        },
        {
          width: 120,
          title: '审批日期',
          ellipsis: true,
          dataIndex: 'checkTime',
          scopedSlots: { customRender: 'checkTime' }
        },
        {
          // width: 230,
          align: 'center',
          title: '审核状态',
          dataIndex: 'checkStatus',
          scopedSlots: { customRender: 'checkStatus' }
        },
        {
          title: '操作',
          dataIndex: 'oherOperation',
          align: 'center',
          fixed: 'right',
          width: 120,
          onFilterDropdownVisibleChange: (e) => this.onFilterDropdownVisibleChange(e, 'expenseReim'),
          scopedSlots: { customRender: 'oherOperation', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' }
        }
      ]
    }
  },
  // computed: {
  //   columns () {
  //     // let { sortedInfo } = this
  //     // sortedInfo = sortedInfo || {}
  //     return
  //   }
  // },
  created () {
    this.geTableColumn('expenseReim')
  },
  mounted () {
    if (this.$store.state.queryCriteria.queryList.expenseReim) {
      this.character = this.queryDataObj = this.$store.state.queryCriteria.queryList.expenseReim
    }
    if (this.$route.query.drawStatus >= 0) {
      this.$set(this.character, 'drawStatus', Number(this.$route.query.drawStatus))
    }
    if (this.$route.query.checkStatus >= 0) {
      this.$set(this.character, 'checkStatus', this.$route.query.checkStatus)
    }
    if (this.$route.query.creator || this.$route.query.dutyPerson) {
      this.character = { ...this.character, ...this.$route.query }
      this.queryDataObj = { ...this.queryDataObj, ...this.$route.query }
    }
    if (this.isIndexPage) {
      // this.pagination = false // 隐藏分页
      this.tableScroll = { y: 166 }
      this.columns = this.indexPageColumns
      this.tableSize = 'small'
      this.pagination.pageSize = 5
    } else {
      this.totals()
    }
    this.initDectData()
    this.initDectDataed()
    // this.initData()
    // console.log(this.$route.query.id, 'this.$route.query')
    if (this.$route.query && this.$route.query.id) {
      this.getById(this.$route.query)
    } else {
      this.initData(this.character)
    }
  },
  // beforeMount () {
  //   this.statistics()
  // },
  methods: {
    clearProject () { // 清除项目
      this.$set(this.queryDataObj, 'projectId', '')
      this.$set(this.queryDataObj, 'projectName', '')
    },
    clearOpportunityTitle () { // 清除销售机会
      this.$set(this.queryDataObj, 'opportunityId', '')
      this.$set(this.queryDataObj, 'opportunityTitle', '')
    },
    statistics () {
      let params = { ...this.character }
      if (this.ids) params.ids = this.ids
      this.$getListStatistics('reimbursement', params, res => {
        let moenyNumber = res
        this.$set(this.footerDataSource, 1, {
          id: '总计',
          amount: '￥' + parseFloat(moenyNumber.amount).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          oherOperation: '-'
        })
      })
    },
    publicDialogSucc (data, typeVal) { // 数据选择成功-赋值
      if (typeVal === 'projectManage') {
        this.$set(this.queryDataObj, 'projectId', data.id)
        this.$set(this.queryDataObj, 'projectName', data.subject)
      } else if (typeVal === 'purchase/supplier') {
        this.$set(this.queryDataObj, 'supplierId', data.id)
        this.$set(this.queryDataObj, 'suppliersName', data.companyName)
      } else if (typeVal === 'salesOpportunities/projectOpportunities') {
        this.$set(this.queryDataObj, 'opportunityId', data.id)
        this.$set(this.queryDataObj, 'opportunityTitle', data.opportunityTitle)
      }
      this.publicDia.visible = false
    },
    publicDialogCancel () { // 取消选择数据
      this.publicDia.visible = false
    },
    openModal (type) { // 弹窗选择一行数据
      this.publicDia.visible = true
      if (type === 'supplier') {
        this.publicDia.title = '选择供应商'
        this.publicDia.comName = 'purchase/supplier'
      } else if (type === 'project') {
        this.publicDia.title = '选择对应项目'
        this.publicDia.comName = 'projectManage'
      } else if (type === 'salesOpportunities') {
        this.publicDia.title = '选择对应销售机会'
        this.publicDia.comName = 'salesOpportunities/projectOpportunities'
      }
    },
    resetAdvancedSearch () {
      this.pagination.current = 1
      this.pagination.pageNum = 1
      this.pagination.pageSize = 10
    },
    // 保存并查询
    advancedSearch () {
      this.resetAdvancedSearch()
      if (this.dataForm && this.dataForm.projectId) {
        this.$set(this.dataForm, 'project', this.dataForm.projectName)
      }
      this.character = { ...this.character, ...this.dataForm, ...this.queryDataObj }
      this.setQueryList({ expenseReim: this.character })
      this.initData(this.character)
      this.statistics(this.character)
    },
    // 直接查询不保存
    save () {
      this.resetAdvancedSearch()
      if (this.dataForm && this.dataForm.projectId) {
        this.$set(this.dataForm, 'project', this.dataForm.projectName)
      }
      let character = { ...this.character, ...this.dataForm }
      this.initData(character)
      this.dataForm = {}
    },
    totals () {
      let dom = this.$el.querySelectorAll('.ant-table-body')[0]
      dom.addEventListener('scroll', () => {
        this.$el.querySelectorAll('.ant-table-body')[1].scrollLeft = dom.scrollLeft
      })
    },
    openView (rowVal, name) {
      this.clickViewVisible = true
      if (name === 'purchaseName') {
        this.$refs.clickViewRef.openView('purchase', rowVal, rowVal.purchaseId)
      } else if (name === 'customerName') {
        this.$refs.clickViewRef.openView('customer', rowVal, rowVal.customerId)
      } else if (name === 'project') {
        this.$refs.clickViewRef.openView('project', rowVal, rowVal.projectId)
      } else if (name === 'contractName') {
        this.$refs.clickViewRef.openView('contract', rowVal, rowVal.contractId)
      } else if (name === 'salesOpportunities') {
        this.$refs.clickViewRef.openView('salesOpportunities', rowVal, rowVal.opportunityId)
      }
    },
    clickViewClose () {
      this.initData(this.character)
      this.clickViewVisible = false
    },
    initDectData () {
      // 客户种类
      this.clientType = this.$store.state.account.dictData.customerTypeList
      this.clientObj = this.$store.state.account.dictData.customerTypeObj
      // 项目负责人
      this.dutyPersonList = this.$store.state.account.dictData.projectPersonList
    },
    publicDrawerClose () { // 公共抽屉关闭
      this.initData(this.character)
      this.publicDrawer = {
        title: '',
        visible: false,
        comName: ''
      }
    },
    queryClick () {
      this.pagination.current = 1
      this.pagination.pageNum = 1
      let character = { ...this.character, ...this.queryDataObj }
      this.character = Object.assign({}, this.character, this.queryDataObj)
      this.initData({ ...character })
      this.setQueryList({ expenseReim: character })
    },
    resetClick () {
      this.character = {
        checkStatus: '',
        drawStatus: ''
      }
      this.dataForm = {}
      this.queryDataObj = {}
      let character = { ...this.character, ...this.queryDataObj }
      this.setQueryList({ expenseReim: character })
      // this.$refs.createTime.reset()
      this.pagination.current = 1
      this.pagination.pageNum = 1
      this.pagination.pageSize = 10
      this.sortedInfo = null
      this.initData(...this.character)
      this.statistics(this.character)
    },
    initDectDataed () {
      this.$get('/common/dict/getListByEn', { dictTypeEn: 'checkStatus' }).then(res => {
        if (res.data.status === 1) {
          let resData = res.data.data
          this.checkStatusList = []
          resData.forEach(item => {
            this.checkStatusList.push({
              label: item.dictName,
              value: item.dictTypeEn
            })
            this.advancedEnquiries[11].content.push({
              label: item.dictName,
              value: item.dictTypeEn
            })
          })
          resData.forEach(item => {
            this.checkStatusObj[item.dictTypeEn] = item.dictName
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    projectChanges (value, name) {
      // this.publicDrawer.visible = false
      if (name === 'project') {
        this.$get('/project/list', { id: value.projectId }).then(res => {
          // this.projectInfo = res.data.data.rows[0]
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.openView(res.data.data.rows[0], 'project')
          } else {
            this.$message.warning('未查询到该数据，可能已删除或者没有操作权限，请检查！', 5)
          }
        })
      }
      if (name === 'customerName') this.openView(value, name)
      if (name === 'purchaseName') this.openView(value, name)
      if (name === 'contractName') this.openView(value, name)
      if (name === 'salesOpportunities') this.openView(value, name)
    },
    exportClick () {
      this.$download('/reimbursement/exportAll', { ...this.character, pageSize: -1, pageNum: -1 }, `${new Date().getTime()}${this.$tree([], 'financialManage/expenseReim/index')}.xlsx`)
    },
    initData (params = {}) {
      this.tableLoadding = true
      // 是否查询审核状态通过&&待支取的
      if (this.isIndexPage) {
        params.checkStatus = 2
        params.drawStatus = 0
      }
      if (this.recycleBinShow) {
        params.delFlag = 1
      } else {
        delete params.delFlag
      }
      params.pageSize = this.pagination.pageSize
      params.pageNum = this.pagination.current
      let { sortedInfo } = this
      if (sortedInfo) {
        params.sortField = sortedInfo.field
        params.sortOrder = sortedInfo.order
      }
      if (this.character.checkStatus !== null && this.character.checkStatus !== '') params.checkStatus = this.character.checkStatus
      if (this.character.drawStatus !== null && this.character.drawStatus !== '') params.drawStatus = this.character.drawStatus
      if (this.ids) params.ids = this.ids
      // console.log(this.ids)
      this.statistics()
      this.$get('/reimbursement/list', params).then(res => {
        if (res.data.status === 1) {
          if (this.isIndexPage) {
            this.tableData = res.data.data.rows
            this.pagination.total = Number(res.data.data.total)
            this.tableLoadding = false
          } else {
            this.tableData = res.data.data.rows
            this.pagination.total = Number(res.data.data.total)
            let arr = []
            for (let item of this.tableData) {
              arr.push(item.amount)
            }
            this.footerDataSource[0].amount = total(arr)[0]
            setTimeout(() => {
              this.tableLoadding = false
            }, 500)
            // this.tableData.forEach(item => {
            //   getProjectNameById(item.projectId).then(res => {
            //     this.$set(item, 'projectName', res)
            //   })
            //   getCustomerNameById(item.customerId).then(res => {
            //     this.$set(item, 'customerName', res)
            //   })
            // })
          }
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    getById (params = {}) {
      this.tableLoadding = true
      // 是否查询审核状态通过&&待支取的
      if (this.isIndexPage) {
        params.checkStatus = 2
        params.drawStatus = 0
      }
      if (this.recycleBinShow) {
        params.delFlag = 1
      } else {
        delete params.delFlag
      }
      params.pageSize = this.pagination.pageSize
      params.pageNum = this.pagination.current
      if (this.character.checkStatus !== null && this.character.checkStatus !== '') params.checkStatus = this.character.checkStatus
      if (this.character.drawStatus !== null && this.character.drawStatus !== '') params.drawStatus = this.character.drawStatus
      this.$get('/reimbursement/getById', params).then(res => {
        if (res.data.status === 1) {
          if (this.isIndexPage) {
            this.tableData.push(res.data.data)
            this.pagination.total = 1
            this.tableLoadding = false
          } else {
            this.tableData.push(res.data.data)
            this.pagination.total = 1
            let arr = []
            for (let item of this.tableData) {
              arr.push(item.amount)
            }
            this.footerDataSource[0].amount = total(arr)[0]
            setTimeout(() => {
              this.tableLoadding = false
            }, 500)
          }
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    pageChange (pageVal, filters, sorter) {
      this.pagination.pageNum = pageVal.current
      this.pagination.pageSize = pageVal.pageSize
      this.pagination.current = pageVal.current
      this.sortedInfo = sorter
      this.initData(this.character)
    },
    recovery (value) {
      const parma = {}
      if (value.parentId) {
        parma.parentId = value.parentId
      }
      parma.linkId = value.id
      parma.recycleType = 9
      this.$get('/recycle/recover', { ...parma }).then(res => {
        if (res.data.status) {
          this.$message.success(res.data.message)
          this.initData()
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    deleteRecy (value) {
      const parma = {}
      if (value.parentId) {
        parma.parentId = value.parentId
      }
      parma.linkId = value.id
      parma.recycleType = 9
      this.$get('/recycle/del', { ...parma }).then(res => {
        if (res.data.status) {
          this.$message.success(res.data.message)
          this.initData(this.character)
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    revocationClick (row) {
      this.$get('/checkDetail/cancel', { recordId: row.id, checkType: 0, isBack: null }).then(res => {
        if (res.data.status === 1) {
          this.$message.success(res.data.message)
          this.initData(this.character)
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    checkClick (rowValue) {
      console.log('审核', rowValue)
      this.$refs.auditRef.formData.checkId = rowValue.id
      this.auditVisible = true
    },
    drawClick (rowVal) { // 点击支取
      if (rowVal.drawStatus === 0) {
        // 未支取
        this.$get('/reimbursement/draw', { id: rowVal.id, drawStatus: 1 }).then(res => {
          if (res.data.status === 1) {
            this.$message.success(res.data.message)
            this.initData(...this.character)
          } else {
            this.$message.warning(res.data.message)
          }
        })
      } else {
        this.$message.warning('该数据已支取,不可重复支取')
      }
    },
    editClick (rowValue) {
      this.addTitle = `[修改]${this.$tree([], 'financialManage/expenseReim/index')}`
      this.addVisible = true
      this.$refs.addEditRef.setForm(rowValue)
    },
    onDelete (rowId) {
      const deleteArr = [rowId]
      this.$get(`/reimbursement/delete`, { ids: deleteArr }).then(res => {
        if (res.data.status === 1) {
          this.$message.success(res.data.message)
          this.initData()
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    subjectClick (id) {
      this.$get('/reimbursement/getById', { id: id }).then(res => {
        let resData = res.data
        if (resData.status === 1) {
          // 展开抽屉
          this.publicDrawer.title = this.$tree([], 'financialManage/expenseReim/index')
          this.publicDrawer.comName = 'financialManage/expenseReim/show.vue'
          this.publicDrawer.visible = true
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(resData.data, null, [resData.data.creator, resData.data.peopleName])
          })
        } else {
          this.$message.warning(resData.message)
        }
      })
    },
    addClick () {
      this.addTitle = `[新建]${this.$tree([], 'financialManage/expenseReim/index')}`
      this.addVisible = true
      this.$nextTick(() => {
        this.$refs.addEditRef.addEdited()
        this.$refs.addEditRef.getDefaultPerson()
      })
    },
    addSuccess () {
      this.addVisible = false
      // this.pagination.current = 1
      // this.pagination.pageNum = 1
      this.initData(this.character)
    },
    addClose () {
      this.initData(this.character)
      this.addVisible = false
    },
    // handleDateChange (value) {
    //   if (value) {
    //     this.$set(this.character, 'reimbursementDateStart', value[0])
    //     this.$set(this.character, 'reimbursementDateEnd', value[1])
    //   }
    // },
    onChangeDateStart (val, mode) {
      this.queryDataObj.reimbursementDateStart = mode
    },
    onChangeDateEnd (val, mode) {
      this.queryDataObj.reimbursementDateEnd = mode
    },
    auditSucc () {
      this.auditVisible = false
      this.initData(...this.character)
    },
    auditClose () {
      this.auditVisible = false
    },
    drawerOnClose () {
      this.drawerVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
// /deep/::-webkit-scrollbar {
//   // width: 0 !important;
//   width: 0.5rem !important;
//   height: .5rem;
// }
/deep/ .ant-table.ant-table-bordered .ant-table-footer {
  padding: 0px;
}
/deep/ .ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0px -1px;
}
/deep/ .ant-table-footer .ant-table-body {
  overflow: hidden !important;
}
/deep/ .ant-table-fixed {
  height: 37px;
}
.pointStyle {
  cursor: pointer;
}
.rightMo {
  width: 100%;
}
.contentdiv {
  width: 100%;
  padding: 4px 0;
}
.add-div {
  text-align: right;
}
.filter-container {
  padding: 4px 0;
  margin: 10px 0;
  background-color: #fff;
}
.filter-row {
  margin-bottom: 14px;
}
.filter-button {
  margin-left: 20px;
}
.filter-item {
  display: inline-block;
  vertical-align: middle;
}
.search-item {
  margin-right: 14px;
  width: 200px;
}
.add-but {
  margin-top: 14px;
}
.content-div {
  background-color: #fff;
  margin: 0 10px;
}
.tableClass {
  /deep/ .ant-table-pagination.ant-pagination {
    margin: 10px 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/financialManage/expenseReim/index.vue